// extracted by mini-css-extract-plugin
export default {"container":"JigjP","content":"_7VwYG","text":"rsEoO","button":"_8P8O9"};